/**
 * useWalletSummary — F-009.3.
 *
 * TanStack Query hook per il summary wallet (saldo/fido/disponibilità).
 * Pattern: `features/admin-wallet/hooks` (query feature-local).
 */
import { useQuery } from '@tanstack/react-query';
import type { WalletSummaryResponse } from '@app/shared';

import { getWalletSummary } from '../lib/wallet-client';
import { walletQueryKeys } from '../lib/query-client';

export function useWalletSummary() {
  return useQuery<WalletSummaryResponse>({
    queryKey: walletQueryKeys.summary,
    queryFn: getWalletSummary,
  });
}
